import {
  Button,
  Typography,
} from "@material-tailwind/react";
import Drawer from '@mui/joy/Drawer';
import ModalClose from '@mui/joy/ModalClose';
import { IoAdd } from "react-icons/io5";
import { AddAgents } from "../services/agentServices";
import { useFormik } from "formik";
import { fetchAgents } from "../redux/slices/agentSlice";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import * as Yup from 'yup';
import { useEffect, useState } from "react";
import ButtonLoader from "../components/ButtonLoader";

export function AddAgentDrawer() {
  const [isOpen, setIsopen] = useState(false);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() =>{
    dispatch(fetchAgents())
  }, [dispatch])
  
  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
      gender: '',
      phoneNumber: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required('Name is required'),
      lastName: Yup.string().required('Name is required'),
      phoneNumber: Yup.string().required('PhoneNumber is required'),
      gender: Yup.string().required('RoleName is required')
        .oneOf(["Male", "Female"], 'Invalid option'),
      email: Yup.string().email('Invalid email address').required('Email is required'),
    }),
    onSubmit: async (values) => {
      setLoading(true);

      const res = await AddAgents(values);
      if(res?.statusCode === 200){
        toast.success(res?.message)
        toast.success('Check your Email for activaiton mail')
        dispatch(fetchAgents())
        setLoading(false)
        setIsopen(false)
      } else if(res?.statusCode === 203){
        toast.error(res?.message)
        setLoading(false)
      }else if(res?.statusCode === 404){
        toast.error(res.message)
        setLoading(false)
      }else if(res?.statusCode === 999){
        toast.error(res.message)
        setLoading(false)
      } else {
        console.error(res.message)
      }
    }
  })
console.log(formik.errors)
  return (
    <div>
        <Button 
           onClick={() => setIsopen(true)} 
          className="bg-primaryRed hover:bg-primaryRed/70 text-white px-4 py-3 flex items-center rounded-md text-lg justify-center whitespace-nowrap outline-none focuse:outline-none border-none">
           <IoAdd className="text-xl mr-1 font-bold text-white"/> 
           <p className="text-sm">Add New Delivery Agent</p>
        </Button>
        <Drawer anchor="right" open={isOpen} onClose={() => setIsopen(false)} size="md"
           slotProps={{
            root: {
              className: `
                backdrop-blur-[1px] 
                bg-orange/20 
                rounded-tl-2xl 
              `,
            },
          }}    
        >
          <ModalClose />
          <div className="flex items-center justify-between gap-4 px-6 pt-10">
            <h1 className="capitalize text-[23px] font-bold text-primaryRed mt-3">Create A Delivery Agent Profile</h1>
          </div>
            <h2 className="mb-6 mt-2 text-[14px] px-5 w-sm text-[#0A0A0A]/80">
              Create a profile for seamless order assignments and track each agent’s performance for quality service.
            </h2>
            <form 
              onSubmit={formik.handleSubmit}
              className="space-y-4 px-5 py-6">
            <div>
              <label htmlFor="firstName" className="text-sm">First Name</label>
              <input 
                id="firstName"
                name="firstName"
                value={formik.values.firstName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="First Name"
                className={`mt-2 border border-[#00000] border-opacity-30 rounded-md px-4 w-full py-1.5 outline-none ring-0 placeholder:text-sm focus:outline-0 `}
              />
              {formik.touched.firstName && formik.errors.firstName ? (
                      <div className='text-sm mt-1 text-red-500'>{formik.errors.firstName}</div>
                ) : null 
              }
            </div>
            <div>
              <label htmlFor="lastName" className="text-sm">Last Name</label>
                <input 
                    id="lastName"
                    name="lastName"
                    value={formik.values.lastName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Last Name"
                    className={`mt-2 border border-[#00000] border-opacity-30 text-sm rounded-md px-4 w-full py-1.5 outline-none ring-0 placeholder:text-sm focus:outline-0 `}
                  />
                      {formik.touched.lastName && formik.errors.lastName ? (
                              <div className='text-sm mt-1 text-red-500'>{formik.errors.lastName}</div>
                        ) : null 
                      }
                  </div>
                  <div>
                    <label htmlFor="phoneNumber" className="text-sm">Phone Number</label>
                    <input 
                        id="phoneNumber"
                        name="phoneNumber"
                        value={formik.values.phoneNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        placeholder="Phone Number"
                        className={`mt-2 border border-[#00000] border-opacity-30 rounded-md px-4 w-full py-1.5 outline-none ring-0 placeholder:text-sm focus:outline-0 `}
                      />
                      {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
                              <div className='text-sm mt-1 text-red-500'>{formik.errors.phoneNumber}</div>
                        ) : null 
                      }
                  </div>
                  <div>
                    <label htmlFor="gender" className="text-sm">Gender</label>
                    <div className="my-2">
                      <select
                        id="gender"
                        name="gender"
                        value={formik.values.gender}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        placeholder="Gender"
                        className="mt-1 border border-[#00000] border-opacity-30 rounded-md px-4 w-full py-1.5 outline-none ring-0 placeholder:text-sm focus:outline-0 text-sm text-[#0A0A0A]/70"
                      > 
                        <option value="" disabled className="text-sm">Gender </option>
                        <option className="text-sm">Male</option>
                        <option className="text-sm">Female</option>
                        {formik.touched.gender && formik.errors.gender ? (
                          <span className='text-sm mt-1 text-red-500'>{formik.errors.gender}</span>
                        ) : null };
                      </select>
                    </div>
                  </div>
                  <div>
                    <label htmlFor="email" className="text-sm">E-mail</label>
                    <input 
                      id="email"
                      name="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="Email"
                      className={`mt-2 border border-[#00000] border-opacity-30 rounded-md px-4 w-full py-1.5 placeholder:text-gray-400 outline-none ring-0 placeholder:text-sm focus:outline-0 `}
                    />
                    {formik.touched.email && formik.errors.email ? (
                        <div className='text-sm mt-1 text-red-500'>{formik.errors.email}</div>
                      ) : null 
                    }
                  </div>
                  <div>
                    <button
                    type="submit"
                    disabled={loading}
                    className="bg-[#FF0000] hover:bg-opacity-50 text-white py-2 w-full mt-4 rounded-md text-md mt-4"
                  >
                  {loading ? <ButtonLoader />
                  : <span> send activation email</span>
                  } 
                  </button>
                  </div>
            </form>
          </Drawer>
    </div>
  );
}
